<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-smartphone";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.75 41.25C2.71875 41.25 1.83625 40.8831 1.1025 40.1494C0.36875 39.4156 0.00125 38.5325 0 37.5V3.75C0 2.71875 0.3675 1.83625 1.1025 1.1025C1.8375 0.36875 2.72 0.00125 3.75 0H22.5C23.5313 0 24.4144 0.3675 25.1494 1.1025C25.8844 1.8375 26.2512 2.72 26.25 3.75V37.5C26.25 38.5313 25.8831 39.4144 25.1494 40.1494C24.4156 40.8844 23.5325 41.2512 22.5 41.25H3.75ZM3.75 31.875V37.5H22.5V31.875H3.75ZM13.125 36.5625C13.6562 36.5625 14.1019 36.3825 14.4619 36.0225C14.8219 35.6625 15.0012 35.2175 15 34.6875C14.9988 34.1575 14.8187 33.7125 14.46 33.3525C14.1012 32.9925 13.6562 32.8125 13.125 32.8125C12.5938 32.8125 12.1488 32.9925 11.79 33.3525C11.4313 33.7125 11.2512 34.1575 11.25 34.6875C11.2488 35.2175 11.4288 35.6631 11.79 36.0244C12.1513 36.3856 12.5962 36.565 13.125 36.5625ZM3.75 28.125H22.5V9.375H3.75V28.125ZM3.75 5.625H22.5V3.75H3.75V5.625Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 48 48"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
>
	<use href="#{symbolId}" />
</svg>
